module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAAAXNSR0IArs4c6QAAASxJREFUOE+NkzFOw0AQRf8YKTRIoU2VWwBHgAgE8QolSIgGIYq0ILpoFoUGrkARhKAAQQpkmxtAHTmpc4o0djzIxlh2YhNPu/P2/9n5S6Z2zj3xHz94b4oSRYqdY4FckWG037rbo2UMHfJLZYa1CYAqQJ133un/B1F4qNjuCqB/G6XvIegUWYwA8+azBi8IVSrx7SNB0B7wrjuvFgERxPYDgJNUwzTPYgKoa2tTAvpe9J+1mACxyheArXlIgDEQtEKLGUBp50hEngteKbKYVehZdfgUDp9Xi4Bi+06Ai5xu92+xicIBD9YNWZ2AwgWmq2BopZ1LEbkt9aypeNRiILGQuzhTO6cQuS8VDWY2hrLhglAvFb6mtvZJqLcCtF65MV4a76a2z3yZPZX9QD/YnY7lTHrUqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jszc_on.png
// module id = qYvn
// module chunks = 1